import { createAction } from '@reduxjs/toolkit';

const changeLoggedIn = createAction('changeLoggedIn');

export default changeLoggedIn;
